import { getTargetContentList, jumpToContent } from '@/utils/figure';
import _ from 'lodash';
import $ from 'jquery';
import PtNodata from '../components/PtNodata';
import { Alert } from '@patsnap/base-components';
import { DualViewRefService } from '@/domains/dual-view/services/dual-view-ref-service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';

export default {
    props: {
        neighborName: { type: String },
        neighborSide: { type: String },
    },
    components: {
        PtNodata,
        BaseAlert: Alert,
    },
    data() {
        return {
            // clms有该属性
            remote_mixin_figPartNotFound: false,
            curFigureContentTargetInfo: {
                length: 0, index: 0, figure: null,
            },
        };
    },
    methods: {
        // 远程调用的加"remote_前缀"
        remote_onFigureClick(figure) {
            this.toFigContent(figure, +1);
        },
        async toFigContent(figure, delta = 0) {
            const vm = this;
            if (!this.figureClickIndexMap) {
                this.figureClickIndexMap = new Map();
            }

            let $contentList = getTargetContentList(figure);
            if (!$contentList.length) {
                this._openNotFoundAlert();
                return;
            }
            if (!this.figureClickIndexMap.has(figure.id)) {
                this.figureClickIndexMap.set(figure.id, 0);
            } else {
                const oldIndex = this.figureClickIndexMap.get(figure.id);
                let assumeNextIndex = oldIndex + delta;
                if (assumeNextIndex >= $contentList.length) {
                    assumeNextIndex = 0;
                }
                if (assumeNextIndex < 0) {
                    assumeNextIndex = $contentList.length - 1;
                }
                this.figureClickIndexMap.set(figure.id, assumeNextIndex);
            }
            const newIndex = this.figureClickIndexMap.get(figure.id);

            jumpToContent(figure, newIndex);

            const createPopper = await import('@popperjs/core').then(m => m.createPopper);

            if (this.tipPopper) {
                this.tipPopper.destroy();
            }

            const targetEle = $contentList.get(newIndex);
            Object.assign(this.curFigureContentTargetInfo || {}, {
                length: $contentList.length,
                index: newIndex,
                figure: figure,
            });


            const enterModi = {
                name: 'enterModi',
                enabled: true,
                phase: 'write',
                fn({ state }) {
                    const content = _.get(state, 'elements.reference');
                    $(vm.$el).find('.fig-tip_entered').removeClass('fig-tip_entered');
                    if (content) {
                        $(content).addClass('fig-tip_entered');
                    }
                },
            };

            // TOC-53323 inline元素换行后会定位换行头尾的中心，其实文本并不在该位置
            // virtual element方式定位 https://popper.js.org/docs/v2/virtual-elements/
            const target = {
                getBoundingClientRect: () => {
                    const rects = targetEle.getClientRects();
                    const rect = targetEle.getBoundingClientRect();
                    // 单行元素使用原始位置定位
                    if (rects.length < 2) return rect;
                    // 多行元素使用第一行的位置定位
                    return {
                        width: rects[0].width,
                        height: rects[0].height,
                        top: targetEle.getBoundingClientRect().top,
                        left: rect.right - rects[0].width,
                    };
                },
            };

            this.tipPopper = createPopper(target, this.$refs.dualFiguresTip, {
                placement: 'top',
                strategy: 'absolute',
                modifiers: [
                    enterModi,
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 8],
                        },
                    },
                ],
            });

            window.rvTrack('Toggle Smart Image Text In Dual', { type: delta ? 'next' : 'pre' });
        },
        closeFigContentTip() {
            try {
                this.tipPopper.destroy();
            } catch (e) { // 吃掉
            }
            this.figureClickIndexMap = new Map();
            $(this.$el).find('.fig-tip_entered').removeClass('fig-tip_entered');

            if (this.neighborName === 'figures') {
                const figsRef = this.dualViewRefService[`${this.neighborSide}Ref`];
                figsRef.focusedId = undefined;
            }
        },
        remote_cleanAll() {
            this.closeFigContentTip();
        },
        _openNotFoundAlert() {
            clearTimeout(this.remote_mixin_figPartNotFound);
            this.remote_mixin_figPartNotFound = setTimeout(() => {
                clearTimeout(this.remote_mixin_figPartNotFound);
                this.remote_mixin_figPartNotFound = false;
            }, 3000);
        },
    },
    created() {
        this.dualViewRefService = injectService(DualViewRefService);
    },
    beforeDestroy() {
        if (this.remote_mixin_figPartNotFound) clearTimeout(this.remote_mixin_figPartNotFound);
    },
};
